import type {
  ChatUiHotelRoomsRate,
  HotelRoomsBlock,
  HotelRoomsRateFilters,
} from './hotel_rooms_schema.js';

/** A tarifa passa em TODOS os chips ligados — a régua dos chips do cartão
 *  (`filterMatches` no intelligence-ui-kit), no vocabulário do bloco. */
export function rateMeetsFilters(
  rate: ChatUiHotelRoomsRate,
  filters: HotelRoomsRateFilters,
): boolean {
  return (
    (!filters.breakfast || rate.breakfast === true) &&
    (!filters.refundable || rate.refundable === true) &&
    (!filters.policy || rate.policyStatus === 'within_policy')
  );
}

/**
 * #5820 (CT-4): os chips com que o cartão de quartos ABRE quando o hotel vem de
 * uma lista recortada — com eles, a tarifa à vista atende ao recorte inteiro.
 * Hotel sem nenhuma tarifa que atenda abre sem chips: o cartão vazio esconderia
 * o hotel que a pessoa acabou de abrir. Régua única do agente (cartão do turno)
 * e da gaveta de detalhes do card.
 */
export function openingRateFilters(
  block: HotelRoomsBlock | null,
  filters: HotelRoomsRateFilters | undefined,
): HotelRoomsRateFilters | undefined {
  if (!block || !filters || Object.keys(filters).length === 0) return undefined;
  const met = block.rooms.some((room) => room.rates.some((r) => rateMeetsFilters(r, filters)));
  return met ? { ...filters } : undefined;
}
